window.dtPosition = function () {
  const dt_position = new DataTable('#position-datatable', {
    processing: false,
    serverSide: true,
    responsive: true,
    ajax: {
      url: $('#position-datatable').data('source'),
      beforeSend: function () { showLoadingRow('#position-datatable', 3); },
      complete: function () { hideLoadingRow(); }
    },
    pagingType: "full_numbers",
    order: [[3, 'desc'], [0, 'asc']],
    columns: [
      { "data": "index" },
      { "data": "status" },
      { "data": "name" },
    ],
    columnDefs: [
    ],
    language: {
      search: ' ',
      sLengthMenu: '_MENU_',
      searchPlaceholder: "Search...",
      info: "Showing _START_ to _END_ of _TOTAL_ entries"
    },
    rowCallback: function (row, data, index) {
      $('td', row).addClass('py-1');
    },
  });

  dtFinalTouch()
}

 